// apiJiraService.js
import axios from 'axios';
import logger from '../utils/logger';
import { createHeaders } from './headerUtils';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const apiJiraService = {
  getIssue: async (issueid) => {
    try {
      const apiUrl = `${BASE_URL}/jira/${issueid}`;
      const headers = createHeaders();
      logger.debug("apiJiraService (ok): getIssue ",`Querying: ${apiUrl}`);
      const response = await axios.get(apiUrl, { headers });
      
      logger.debug("apiJiraService (ok): getIssue ",`response: `,response);
      const parsedData = JSON.parse(response.data);
      return parsedData;
    } catch (error) {
      logger.error("apiJiraService (ERROR): getIssue ", error);
      throw error;
    }
  },

  addRequestparticipant: async (issueid) => {
    try {
      const apiUrl = `${BASE_URL}/jira/addrequestparty/${issueid}`;
      const headers = createHeaders();
      console.log("apiJiraService (ok): addRequestparticipant ", `Querying: ${apiUrl}`);
      const response = await axios.post(apiUrl, {}, { headers });
      console.log("apiJiraService (ok): addRequestparticipant ", response);
      return response.data;
    } catch (error) {
      console.log("apiJiraService (ERROR): addRequestparticipant ", error.message);
      throw error;
    }
  },

  removeRequestparticipant: async (issueid) => {
    try {
      const apiUrl = `${BASE_URL}/jira/removerequestparty/${issueid}`;
      const headers = createHeaders();
      console.log("apiJiraService (ok): removerequestparty ", `Querying: ${apiUrl}`);
      const response = await axios.post(apiUrl, {}, { headers });
      return response.data;
    } catch (error) {
      console.log("apiJiraService (ERROR): removerequestparty ", error.message);
      throw error;
    }
  },

  getrelatedTickets: async (opID, opptouse) => {
    try {
      const apiUrl = `${BASE_URL}/jira/getrelatedTickets/${opID}/${opptouse}`;
      const headers = createHeaders();
      const response = await axios.get(apiUrl, { headers });
      return response.data;
    } catch (error) {
      console.log("apiJiraService (ERROR): getrelatedTickets ", error.message);
      throw error;
    }
  },

  searchBySalesforceId: async (salesforceId) => {
    try {
      const apiUrl = `${BASE_URL}/jira/searchBySalesforceId/${salesforceId}`;
      const headers = createHeaders();
      logger.debug("apiJiraService (ok): searchBySalesforceId ", `Querying: ${apiUrl}`);
      const response = await axios.get(apiUrl, { headers });
      logger.debug("apiJiraService (ok): searchBySalesforceId ", `response: `, response);
      return response.data;
    } catch (error) {
      logger.error("apiJiraService (ERROR): searchBySalesforceId ", error);
      throw error;
    }
  },
};

export default apiJiraService;
